import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Skeleton } from '@/shared/ui';

import { FULL_HEAD_MPR_SLICE_PLACEHOLDERS } from '../../config';

import styles from './FullHeadMprSlicesLoadingPlaceholder.module.scss';

type FullHeadMprSlicesLoadingPlaceholderProps = {
  height: number;
  className?: string;
  setNodeRef?: (node: HTMLDivElement | null) => void;
};

export const FullHeadMprSlicesLoadingPlaceholder: FC<
  FullHeadMprSlicesLoadingPlaceholderProps
> = (props) => {
  const { height, className, setNodeRef } = props;
  const { formatMessage } = useIntl();

  return (
    <div
      ref={setNodeRef}
      data-component="mpr-slices-loading"
      className={cn(styles.container, className)}
      role="status"
      aria-label={formatMessage({
        id: 'global.loading',
        defaultMessage: 'Loading…',
      })}
    >
      {FULL_HEAD_MPR_SLICE_PLACEHOLDERS.map(({ aspectRatio, key }) => (
        <Skeleton
          key={key}
          width={Math.round(height * aspectRatio)}
          borderRadius={8}
          height={height}
        />
      ))}
    </div>
  );
};
